export default function ReviewsList({ reviews }) {
	return (
		<div className="dashboard-card full">
			<div className="card-head">
				<div>
					<p className="panel-overline">Avis récents</p>
					<h3>Google Reviews</h3>
				</div>
			</div>
			<div className="reviews-grid">
				{reviews.map((review) => (
					<div key={review.id} className="review-card">
						<div className="review-top">
							<strong>{review.name}</strong>
							<span className="stars">{"★".repeat(review.rating)}</span>
						</div>
						<p className="review-comment">{review.comment}</p>
						<span className="muted">{review.timestamp}</span>
					</div>
				))}
			</div>
		</div>
	);
}
